export const CRON_JOB_INTERVALS = {
  EVERY_5_SECONDS: "*/5 * * * * *",
  EVERY_10_SECONDS: "*/10 * * * * *",
  EVERY_30_SECONDS: "*/30 * * * * *",
  EVERY_MINUTE: "* * * * *",
  // second offsets keep jobs hitting the same exchange endpoint out of the same second
  EVERY_MINUTE_AT_20_SECONDS: "20 * * * * *",
  EVERY_MINUTE_AT_40_SECONDS: "40 * * * * *",
  EVERY_4_MINUTES: "*/4 * * * *",
  EVERY_5_MINUTES: "*/5 * * * *",
  EVERY_5_MINUTES_AT_30_SECONDS: "30 */5 * * * *",
  // same as every 5 minutes, but offset by 3 / 6 minutes — for staggering the
  // same job across environments that share a per-account exchange rate limit.
  // The 6-min offset fires at :06,:11..:56 (11 runs/hour, 10-min gap over the hour mark).
  EVERY_5_MINUTES_OFFSET_BY_3_MIN: "3-59/5 * * * *",
  EVERY_5_MINUTES_OFFSET_BY_6_MIN: "6-59/5 * * * *",
  EVERY_5_MINUTES_OFFSET_BY_3_MIN_AT_30_SECONDS: "30 3-59/5 * * * *",
  EVERY_5_MINUTES_OFFSET_BY_6_MIN_AT_30_SECONDS: "30 6-59/5 * * * *",
  EVERY_10_MINUTES: "*/10 * * * *",
  // same as every 10 minutes, but offset by 3 minutes
  EVERY_10_MINUTES_OFFSET_BY_3_MIN: "3-59/10 * * * *",
  // same as every 10 minutes, but offset by 6 minutes
  EVERY_10_MINUTES_OFFSET_BY_6_MIN: "6-59/10 * * * *",
  EVERY_15_MINUTES: "*/15 * * * *",
  EVERY_30_MINUTES: "*/30 * * * *",
  EVERY_TUESDAY_AND_FRIDAY_AT_9AM: "0 9 * * 2,5",
  EVERY_HOUR: "0 * * * *",
  EVERY_HOUR_OFFSET_BY_15_MIN: "15 * * * *", // 00:15, 01:15, 02:15, etc.
  EVERY_HOUR_OFFSET_BY_30_MIN: "30 * * * *", // 00:30, 01:30, 02:30, etc.
  EVERY_HOUR_AT_45_MINUTES: "45 * * * *", // 00:45, 01:45, 02:45, etc.
  EVERY_6_HOURS: "0 */6 * * *",
  EVERY_DAY: "0 0 * * *",
  // 1-minute offset past UTC midnight: avoids racing in-flight writes right at
  // 00:00 UTC and gives any bot ticks landing at 23:59:59 UTC time to persist
  // their `completedAt` before the daily referral epoch builder reads them.
  EVERY_DAY_AT_1_MINUTE_PAST_MIDNIGHT: "1 0 * * *",
  EVERY_DAY_AT_2AM: "0 2 * * *",
  EVERY_DAY_AT_10AM: "0 10 * * *",
  // we slightly shift the time by 2 minutes to avoid cases where the weekly report was published
  // slightly later for the 1st job execution and earlier for the 2nd job execution.
  EVERY_DAY_AT_4PM_2_MINUTES_LATER: "2 16 * * *", // 4:02 PM UTC
} as const;
